import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { changeUserEmail } from '../core/_requests';
import { useMutation } from '@tanstack/react-query';
import { SystemNotification } from '@/app/components/feedback/SystemNotification';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  initialUserChangeEmailRequestDto,
  type UserChangeEmailRequestDto,
} from '../../../../models/UserChangeEmailRequestDto';
import { getErrorMessage } from '@/api/core/axiosErrorMapper';

const formSchema = Yup.object().shape({
  email: Yup.string().email('Email inválido').required('Email é obrigatório'),
});

type Props = {
  show: boolean;
  onClose: () => void;
  email: string;
};

function EditUserModal({ show, onClose, email }: Props) {
  const navigate = useNavigate();

  const formik = useFormik<UserChangeEmailRequestDto>({
    initialValues: initialUserChangeEmailRequestDto,
    validationSchema: formSchema,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      editMutation.mutate(values);
    },
  });

  const editMutation = useMutation({
    mutationFn: (newUserEmail: UserChangeEmailRequestDto) => changeUserEmail(newUserEmail),

    onSuccess: () => {
      SystemNotification.success('Email alterado com sucesso');
      onClose();
      navigate('', { state: { refreshDatatable: true } });
    },

    onError: (error) => {
      SystemNotification.error(getErrorMessage(error));
    },
  });

  const handleExited = () => {
    formik.resetForm();
  };

  return (
    <Modal show={show} onExited={handleExited} onHide={onClose}>
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Editar usuário</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body d-flex flex-column flex-sm-row items-center justify-content-around">
          <div className="justify-content-center w-100 px-1 px-md-8">
            <div className="d-flex flex-column gap-7">
              <div className="form-group">
                <label className="form-label fs-6 fw-bold text-gray-700 required">E-mail atual</label>
                <input disabled className="form-control" id="code" type="text" value={email} />
              </div>
              <div className="form-group">
                <label className="form-label fs-6 fw-bold text-gray-700 required">Novo e-mail</label>
                <input
                  className="form-control"
                  id="email"
                  placeholder="Email"
                  type="text"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                />
                {!!formik.errors.email && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.email}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="text-gray-600" variant="secondary" onClick={onClose}>
            Cancelar
          </Button>
          <Button className="btn btn-primary" disabled={editMutation.isPending} type="submit">
            {editMutation.isPending ? 'Salvando...' : 'Salvar'}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default EditUserModal;
